import gql from 'graphql-tag';

export const ExternalWhiteboardTokenQuery = gql`
	query ExternalWhiteboardTokenQuery($shareToken: String!) {
		externalCanvasToken(shareToken: $shareToken) {
			token
		}
		externalContentMediaSession(shareToken: $shareToken) {
			accessTokens {
				readOnlyToken {
					value
				}
				readWriteToken {
					value
				}
			}
			configuration {
				fileStoreUrl
			}
		}
		entitlements {
			whiteboardFeatures {
				smartConnectors {
					isEntitled
				}
				smartSections {
					isEntitled
				}
			}
		}
	}
`;
